import React from "react";

export default function ProductFetch(props: any) {
  return (
    <div className="p-8 text-center text-gray-500 bg-white rounded-xl border border-gray-200">
      Product Fetch is not configured for this client.
    </div>
  );
}
